
import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import loginimage from "../../../Assets/login/login.jpg";
import item3 from "../../../Assets/login/item3.svg";
import { useLocation, } from "react-router-dom";

import axios from "../../../axiosInstance.js";
import { useNavigate } from "react-router-dom";
import { useRecoilState } from "recoil";
import { tokenState, userIdState, typeState } from "../../../Auth/Atoms.jsx";
import "./LoginPage.css";
import "bootstrap/dist/css/bootstrap.min.css";
import { Input } from '@mui/material';
import IconButton from "@mui/material/IconButton";
import InputAdornment from "@mui/material/InputAdornment";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import { useDispatch } from "react-redux";
import encrypt from "../../../Services/Encryption/Encyption.js";
import { login } from "./authSlice";
import Navbar from "../../../Component/Home/Navbar.jsx";
import Footer from "../../../Component/Home/footer/Footer.jsx";

// import Loader from '../../../Component/Loader.jsx'
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ModalBox from "../../../Component/ModalBox/ModalBox.jsx";
import { useModal } from "../../../context/ModalContext.jsx";
import { validateToken } from "../../../Auth/authUtils.js";
import ZohoTest from "../../../Component/ZohoTest.jsx";

function Login() {

  const navigate = useNavigate();
  const [isCheckingAuth, setIsCheckingAuth] = useState(true);

  const [loading, setLoading] = useState(true);
  const [alertInfo, setAlertInfo] = useState({
    show: false,
    message: "",
    severity: "info",
  });
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [phoneError, setPhoneError] = useState(null);

  const [otp, setOtp] = useState("");
  const [rememberMe, setRememberMe] = useState(false);
  const [isHovered, setIsHovered] = useState(false);
  const [token, setToken] = useRecoilState(tokenState);
  const [userId, setUserId] = useRecoilState(userIdState);
  const [typeOf, setTypeOf] = useRecoilState(typeState);
  const [showPassword, setShowPassword] = useState(false);
  const [fontSize, setFontSize] = useState("35px");
  const [emailError, setEmailError] = useState("");
  let [passwordError, setPasswordError] = useState("");

  const publicVapidKey =
    "BI0sWPKFjmxnkWYcwjylL7qmo9svTNzEyuEG8-xyswDkQ_FKbONR1yQ6CAUZ9EsryyJiQATfDUZnfloTn8z9DS0";

  const dispatch = useDispatch();
  const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  const passwordRegex =
    /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;

  // useEffect(() => {
  //   const checkLogin = async () => {
  //     const isValid = await validateToken();
  //     const userRole = localStorage.getItem("userRole");
  //     const currentStep = localStorage.getItem("currentStep");

  //     if (isValid) {
  //       if (userRole === "crane") {
  //         navigate("/crane-driver-home", { replace: true });
  //       } else if (userRole === "customer") {
  //         if (currentStep === "01") {
  //           navigate("/addVehicles/select-location", { replace: true });
  //         } else if (currentStep === "02") {
  //           navigate("/addVehicles/add-images", { replace: true });
  //         } else if (["03", "04"].includes(currentStep)) {
  //           navigate("/addVehicles/choose-vehicle", { replace: true });
  //         } else if (currentStep == '05') {
  //           navigate('../addVehicles/confirmation', { replace: true })
  //         } else {
  //           navigate("/customer-home-page", { replace: true });
  //         }
  //       } else {
  //         navigate("/loginPage", { replace: true });
  //       }
  //     } else {
  //       setIsCheckingAuth(false); // show login form only if not logged in
  //     }
  //   };

  //   checkLogin();
  // }, []);


  useEffect(() => {
    const checkLogin = async () => {
      const isValid = await validateToken();
      const userRole = localStorage.getItem("userRole");
      const currentStep = localStorage.getItem("currentStep");

      if (isValid) {
        if (userRole === "crane") {
          navigate("/crane-driver-home", { replace: true });
        } else if (userRole === "customer") {
          // if (currentStep === "01") {
          //   navigate("/addVehicles/select-location", { replace: true });
          // } else if (currentStep === "02") {
          //   navigate("/addVehicles/add-images", { replace: true });
          // } else if (["03", "04"].includes(currentStep)) {
          //   navigate("/addVehicles/choose-vehicle", { replace: true });
          // }else if(currentStep == '05'){
          //     navigate('../addVehicles/confirmation', {replace:true})
          //   } else {
          //   navigate("/customer-home-page", { replace: true });
          // }

          navigate("/customer-home-page", { replace: true });


        }
        else if (userRole === "recoveryVan") {
          navigate("/crane-driver-home", { replace: true });
        }
        else if (userRole === "craneandrecoveryVan") {
          navigate("/crane-driver-home", { replace: true });
        }

        else if (userRole === "vendorDriver") {
          navigate("/vendor-driver-home", { replace: true });
        }
        else if (["Management", "IT", "Operations", "HR"].includes(userRole)) {
          navigate("/admin-dashboard-vendor-customer", { replace: true });
        }
        else {
          navigate("/loginPage", { replace: true });
        }
      } else {
        setIsCheckingAuth(false); // show login form only if not logged in
      }
    };

    checkLogin();
  }, []);



  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth <= 360) {
        setFontSize("20px");
      } else {
        setFontSize("30px");
      }
    };

    window.addEventListener("resize", handleResize);
    handleResize();

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const savedEmail = localStorage.getItem("rememberedEmail");
    const savedPassword = localStorage.getItem("rememberedPassword");
    const rememberMeFlag = localStorage.getItem("rememberMe") === "true";

    if (savedEmail && rememberMeFlag) {
      setEmail(savedEmail);
      // setOtp(savedPassword);
      setRememberMe(rememberMeFlag);
    }
  }, []);

  const handlePhoneChange = (e) => {
    const newPhone = e.target.value;
    setPhone(validatePhoneNumber(newPhone));
    if (e.target.value.trim() !== '') {
      setHasError(false);
    }


    if (!showLoginBtn) {
      setShowLoginBtn(true)
    }


    if (modalData.isOpen) {
      closeModal()
    }

  };

  const validatePhoneNumber = (value) => {
    let updatedValue = value.replace(/\D/g, ''); // Remove non-digit characters
    if (updatedValue && updatedValue[0].match(/[6-9]/)) {
      updatedValue = updatedValue.slice(0, 10); // Only keep up to 10 digits if it starts with 6-9
    } else {
      updatedValue = ''; // Return an empty string if the first digit isn't between 6-9
    }
    return updatedValue
  }

  const handleOtpChange = (e) => {

    // Allow only numbers and limit to 6 digits
    if (/^\d{0,6}$/.test(e.target.value)) {
      setOtp(e.target.value);
    }
    // setOtp(e.target.value);

    if (modalData.isOpen) {
      closeModal()
    }
  };

  const handleRememberMeChange = (e) => {
    setRememberMe(e.target.checked);
  };

  const togglePasswordVisibility = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setShowPassword(!showPassword);
  };

  const urlBase64ToUint8Array = (base64String) => {
    const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
    const base64 = (base64String + padding)
      .replace(/-/g, "+")
      .replace(/_/g, "/");
    const rawData = window.atob(base64);
    return Uint8Array.from([...rawData].map((char) => char.charCodeAt(0)));
  };

  const sendLoginNotification = async (getUserId, getToken) => {
    try {
      console.log("Registering service worker...");
      const registration = await navigator.serviceWorker.register(
        "/service-worker.js"
      );
      console.log("Service worker registered:", registration);

      const subscription = await registration.pushManager.subscribe({
        userVisibleOnly: true,
        applicationServerKey: urlBase64ToUint8Array(publicVapidKey),
      });
      console.log("Push Manager subscription:", subscription);

      await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/api/subscription/${getUserId}`,
        subscription,
        { headers: { Authorization: `Bearer ${getToken}` } }
      );
    } catch (error) {
      console.error("Error sending login notification:", error);
    }
  };

  const [loginData, setLoginData] = useState({});
  const [showLoginBtn, setShowLoginBtn] = useState(true);
  const [otpForTemp, setOtpForTemp] = useState(false);

  const [isLoading, setIsLoading] = useState(false);

  const showSuccessToast = (e) => {
    toast.success(e);
  };

  const showErrorToast = (e) => {
    toast.error(e);
  };

  const validatePhone = (phone) => {
    const regex = /^[6-9]\d{9}$/;
    return regex.test(phone);
  }

  const getOtp = async (e) => {

    try {

      e.preventDefault();

      setHasError(false)
      setOtpHasError(false)
      setErrorInputName(null)

      setOtp("")

      if (!validatePhone(phone)) {
        setHasError(true)

        setErrorInputName('phone')
        openModal({
          title: 'Error',
          body: 'Please enter valid phone Number',
          iconType: 'error',
          autoClose: true,
        });
        return;
      }

      // setPhoneError(null)

      const encryptedPhone = await encrypt(phone);
      // return

      setIsLoading(true)
      let response = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/generateOtpAndSend`,
        {
          phoneNumber: encryptedPhone.encryptedData,
          phoneNumberIv: encryptedPhone.iv,
        }
      );

      console.log('OTP Response: ');
      console.log(response);

      if (!response || !response.data.otp) {
        // showErrorToast('OTP error occurred!')
        openModal({
          title: 'Error',
          body: 'OTP error occurred!',
          iconType: 'error',
          autoClose: true,
        });
        console.log('OTP is missing from Get OTP Response Method');
        return
      }


      // showSuccessToast('OTP generated and sent successfully!')
      openModal({
        title: 'Success',
        body: 'OTP sent successfully',
        iconType: 'success',
        autoClose: true,
      });


      setTimeout(() => {
        otpInput.current?.focus();
      }, 1000);


      setShowLoginBtn(false)
      // TODO: Comment this line when OTP autofill is not required
      // setOtp(response.data.otp)     
      if (response.data?.tempAccount == true) {
        setOtpForTemp(true);
      }

      const otpSent = true;
      if (otpSent) {
        setTimeLeft(120);
      }

      setOTPList([...optList, response.data.otp])


    } catch (error) {
      console.log("Error occurred: ", error);
      console.log(error.response.data);
      setHasError(true)
      setErrorInputName('phone')

      if (error?.response?.data?.message === 'Phone number is not registered with us') {
        openModal({
          title: 'Error',
          body: 'Phone number is not registered. Please click below to sign up',
          iconType: 'error',
          autoClose: false,
          actionLabel: 'Sign Up',
          onAction: () => {
            localStorage.setItem('newNumber', phone)
            navigate('/SignUp')
            closeModal();
          }
        });
        return
      }
      openModal({
        title: 'Error',
        body: error.response.data.message || 'Internal server error occurred!',
        iconType: 'error',
        autoClose: true,
      });

    }
    finally {
      setIsLoading(false)

    }


    //     localStorage.setItem("token", "caeb014ec62a947c72cacb87ab3197f061be7bd1a0126a1783f0cef43f3658680f9108adef53a9c6e994700cc35b8ad6aa7f920b610b9afa982544a9ccb6b9c6cdbda23d01ef340e401bcf3c6c3796eaf33a1f00f2b8f9393808e0eec852002543406f425f96c1d7d2be0138f9345168d56bf42c28079426fdca8aff5bf23b1354e12dd05d8b4c686b26e2789dbb7e2c6eec087592b679d3b862bb198fb9d9c512ede552c088b92485758235c25132b993c33c136171b14c726965aa65c9e2d99c85c70011cce53b2115dff0b064bcba70cf833bd91ac2ee86de3d401c773e3cac383bd20e8351cb11add783d811e32b");
    // localStorage.setItem("userId", "VED-5db2e64c-142c-4d5c-a373-13d622ba4c52");
    // localStorage.setItem("loginId", "LOG-778956e1-aafb-49ba-b147-a15107f6a0b7");
    // localStorage.setItem("loginTime", "1751799646201");
    // localStorage.setItem("userRole", "vendorDriver");
    // localStorage.setItem("userType", "recoveryVan");

    // localStorage.setItem("token", "e162f6b02504c2670be0103657f532370fbf897927add2530d40a637ef9a892738c4074d616ec8fa15699d3a60f687e9b3fcd109484dc7fdd2ad1dc0c819dd48f9ee4874c66821a874d4aeeed8d5c45d444b3929b9172bf0cd28ba6269ab111772bee737df72058a5d0ad4c93a7ae820366422604b5b56003a2eafef38b6b4d65186b54f5e7b0a5682a548afa72feba8661f5e1c6fa48b7657ce3e8265d286417aae9d024d005e8c40860ceff8289f9beaf191cca6356b6ee85002a05f4cd6edd8168727439a6018b808492ab0e59317735d6ea4ff87ce8a9bb79b86467a31933abc5f1054b70179f304511163f18572");
    // localStorage.setItem("userId", "VC-e65cb7a0-05be-40b0-b254-9278ecb650d5");
    // localStorage.setItem("loginId", "LOG-4aa15e86-5462-4ede-b70d-5e4fc96a0061");
    // localStorage.setItem("loginTime", "1751804777129");
    // localStorage.setItem("userRole", "recoveryVan");
    // localStorage.setItem("phoneNumber", "c4fd1f9343ab088f586c35e4e5c985aa");
    // localStorage.setItem("phoneNumberIv", "67e97a6ae8541f51a5fa954649cb8124");
    // localStorage.setItem("otp", "7ec87810f13069421b650061d703683c");
    // localStorage.setItem("otpIv", "af14adc915a583ccdb6cbe7879dc0297");
    // localStorage.setItem("vendorPhone", "9999999999");

    //     localStorage.setItem("iconify-version", "iconify2");
    // localStorage.setItem("iconify-count", "0");
    // localStorage.setItem("token", "577192483f7be6cef1d01a338bb496a228b830314afc9c51836676f8899aa6cbb78e8221d6473b35d47dcef36260c069099e040c2d3738c74fc0aa09d9ca23b22c5abc4dfa26e5f8c0dbfe31edadcc8156a993e909a9af1aff605c77930a9561c29be543d8235e70a40f755f0e2c2a138b5fec4ef5ee92305ccd75bf6f2a7730c8c610268e215bbdeb0a44ff8b77fa185b65fad1c352a6dbd707e0d9624c4d47ea82a8ec51fedb6fbc5961a9086fa7b2d1b9cf3cb598732a9315881b29290ef97307c1d8e386abdfde0927199a842884");
    // localStorage.setItem("userId", "CC-2ebbe9ff-d659-4573-94b3-1049eac0f2c8");
    // localStorage.setItem("loginId", "LOG-f16f25a8-41e3-444e-8041-a311b214b90f");
    // localStorage.setItem("loginTime", "1750934482390");
    // localStorage.setItem("userRole", "customer");
    // localStorage.setItem("fromLogin", "true");
    // localStorage.setItem("justLoggedIn", "true");
    // navigate('/customer-home-page')


    // localStorage.setItem("token", "c8259c7b54e5ec131f357a4820662cfc0a504d25736dc11f4052a1d1f0788637e6d598bdfcfadb7a5ca0da5bc59bfcf65fc6e782f5c23a2cb6cca73929b369171196d7f7a1e3d355ee4199e637ace31696656b1199675b97ef5a139f0e8f791bfb0ca53e6eadd095b512be73e10888f747003497baa31fbe7b66efdd35d22b4b5241cec9a32248fe55a7ee1a86412a11afdad04714eae6c14a6f2ec535566058743a5d70a27bec74d24068927decd3b66de648ad0d21cd14cc24def55749e544f46488c33850f776e6278c9919aff0e7b1c8c53bea5705cebb1e59c8aca4a314");
    // localStorage.setItem("userId", "CC-ea5ff8d5-9058-476a-8df1-97ddc452f010");




    //   const oneKmInLat = 5 / 111.32; // ≈ 0.008983
    // const oneKmInLng = 5 / (111.32 * Math.cos(latitude * (Math.PI / 180)));

    // const newLatitude = latitude + oneKmInLat;
    // const newLongitude = longitude + oneKmInLng;

    // localStorage.setItem("iconify-version", "iconify2");
    // localStorage.setItem("iconify-count", "0");
    // localStorage.setItem("token", "048f679cd43899171d1b61c29147f68ba15d4cb773c081bf83a9d578eb80f2891774b87c6dd6a69a0eb2e32afa06855dca7baade74629fd614d4cfb6e4be68829b314c937a2155503b49068d951aab29c86a16c47480d9a71f1314b56e873e38bdb077510c12314c6a3e0e15b41c3de4c13006dc7317b230d10e201839af3533fcd5c83cc271f94d16186935eaecec4db21e4e6be32231f5bd7ac306a0fd9b73995cfec38b8cab10862d19beeb993b096395f943775568f21d9ec55655174b41b55a40570951a5dae9285542881afd763871fa3d7351d7c5c6e0e9ad35013c32f7c3c10f8c42b07d6e007026915632d0");
    // localStorage.setItem("userId", "VED-5db2e64c-142c-4d5c-a373-13d622ba4c52");
    // localStorage.setItem("loginId", "LOG-acf8242f-1de7-4fc0-8549-7cec3e6a1a20");
    // localStorage.setItem("loginTime", "1751188548400");
    // localStorage.setItem("userRole", "vendorDriver");
    // localStorage.setItem("userType", "recoveryVan");
    // navigate('/vendor-driver-home')

    // localStorage.setItem("iconify-count", "0");
    // localStorage.setItem("iconify-version", "iconify2");
    // localStorage.setItem("token", "1d986c8a5d72abc69e84810f185640745fe64c3fb29ae9e26dbff7e7022c3a641662a5a6a51d41778c07830585166e31caf189181ebb02d48f71b64a9e1fa0797eb5b37a360796b87cbc4e5ba8cab7a8b367a9f36a10e6e3d8884c62396ff0ceb380c8a2c94d1ce6fd174771a01fe4ccf300664017d98a6080c3a8055d0ab61c6340f401194a110008b12775970dddd43b26da37981b1efc4dba5b14a06001ccaf48629dfd4113998cc15d0abc37265d57135a170a2a06876da3aaa0e9b934d5143a21340f604259eb6addcf68ef6e608696b652a0730a3986ec604c5c902f09e96bb26f4ce6636ee4b519a769c275d5");
    // localStorage.setItem("userId", "VC-e65cb7a0-05be-40b0-b254-9278ecb650d5");
    // localStorage.setItem("loginId", "LOG-61b9715a-074e-4a89-8eda-d71af7c5435a");
    // localStorage.setItem("loginTime", "1750756982126");
    // localStorage.setItem("userRole", "recoveryVan");
    // localStorage.setItem("phoneNumber", "9b85b0c43111ea8158f151e3092f34da");
    // localStorage.setItem("phoneNumberIv", "08a0b74a6bb7849d49fc3bb077e791c1");
    // localStorage.setItem("otp", "aeb5db6eefca85fe1a2ca583591aa047");
    // localStorage.setItem("otpIv", "10b07f78b265d20e95380161a6f51b06");
    // localStorage.setItem("vendorPhone", "9999999999");
    // navigate('/crane-driver-home')


  };


  const handleSubmit = async (e) => {
    console.log('handleSubmit calling: ');

    try {


      e.preventDefault();
      if (modalData.isOpen) {
        closeModal()
        return
      }

      const found = optList.includes(otp.trim());

      console.log(optList)
      console.log('OTP found: ===================== ')
      console.log(found)

      if (showRetry && found) {
        openModal({
          title: 'Error',
          body: 'OTP has expired. Please click on resend OTP to get new OTP',
          iconType: 'error',
          autoClose: true,
        });
        return
      }

      setHasError(false)
      setOtpHasError(false)
      setErrorInputName(null)
      closeModal()

      if (!validatePhone(phone)) {
        setHasError(true)

        setErrorInputName('phone')
        openModal({
          title: 'Error',
          body: 'Please enter valid phone Number',
          iconType: 'error',
          autoClose: true,
        });
        return;
      }

      if (otp === "") {
        // setPhoneError('Mobile Number is required')       
        setOtpHasError(true)
        setErrorInputName('otp')
        openModal({
          title: 'Error',
          body: 'Please provide OTP number',
          iconType: 'error',
          autoClose: true,
        });
        return;
      }

      setIsLoading(true)

      const encryptedPhone = await encrypt(phone);
      const encryptedOtp = await encrypt(otp);

      let obj = {
        phoneNumber: encryptedPhone.encryptedData,
        phoneNumberIv: encryptedPhone.iv,
        otp: encryptedOtp.encryptedData,
        otpIv: encryptedOtp.iv,
      }

      // console.log('obj ', obj)

      console.log('Login Response: ');
      let response = null;
      const url = otpForTemp == true ? `${process.env.REACT_APP_BACKEND_URL}/api/loginForTempAccount` : `${process.env.REACT_APP_BACKEND_URL}/api/login`;

      try {
        response = await axios.post(
          url,
          {
            phoneNumber: encryptedPhone.encryptedData,
            phoneNumberIv: encryptedPhone.iv,
            otp: encryptedOtp.encryptedData,
            otpIv: encryptedOtp.iv,
          }
        );
      } catch (error) {
        console.log(error);

        console.log(error.message)

        if (error.message.toLowerCase() === 'network error') {
          openModal({
            title: 'Error',
            body: error.message,
            iconType: 'error',
            autoClose: true,
          });
          return
        }


        console.log(error?.response?.data?.message.toLowerCase())

        let msg = error?.response?.data?.message?.toLowerCase()

        if (msg.includes('phone')) {
          setErrorInputName('phone')
          setHasError(true)
          // setOtpHasError(false)

        }
        if (msg.includes('otp')) {
          setErrorInputName('otp')
          // setPhoneError(false)
          setOtpHasError(true)

          if (msg === 'incorrect otp.') {
            openModal({
              title: 'Error',
              body: 'Incorrect OTP number',
              iconType: 'error',
              autoClose: true,
            });
          }
          return

        }

        openModal({
          title: 'Error',
          body: msg || error.message,
          iconType: 'error',
          autoClose: true,
        });


        // otpInput?.current?.focus()
        return
      }

      console.log(response);

      // return

      if (response.status === 200) {

        console.log("userType", response.data.data.userType);

        const dept = response.data.data.department?.trim();
        const normalizedDept = dept?.toLowerCase();
        if (response.data.data?.userType === "admin" || ["management", "it", "operations", "hr"].includes(normalizedDept)) {
          setupCommonLoginDetails(response)
          localStorage.setItem("userRole", dept || "Management");
          navigate("../admin-dashboard-vendor-customer");
        } else if (response.data.data.vendorType === "advocate") {
          setupCommonLoginDetails(response)
          localStorage.setItem("userRole", "advocate");
          navigate("../advocateDashboard");
        } else if (response.data.data.vendorType === "mechanic") {
          setupCommonLoginDetails(response)
          localStorage.setItem("userRole", "mechanic");
          navigate("../MechanicDashboard");
        } else if (response.data.data.vendorType === "crane") {
          setupCommonLoginDetails(response)
          localStorage.setItem("userRole", "crane");
          localStorage.setItem('phoneNumber', obj.phoneNumber)
          localStorage.setItem('phoneNumberIv', obj.phoneNumberIv)
          localStorage.setItem('otp', obj.otp)
          localStorage.setItem('otpIv', obj.otpIv)
          localStorage.setItem('vendorPhone', response.data.data.vendorPhone)
          localStorage.setItem('vendorName', response.data.data.vendorName)

          // let showWelcomePage = localStorage.getItem('showWelcomePage')
          // if (!showWelcomePage) {
          //   navigate('/welcome-page')
          //   localStorage.setItem('showWelcomePage', true)
          // } else {
          navigate('/crane-driver-home')
          // }

        } else if (response.data.data.vendorType === "recoveryVan") {
          setupCommonLoginDetails(response)
          localStorage.setItem("userRole", "recoveryVan");
          localStorage.setItem('phoneNumber', obj.phoneNumber)
          localStorage.setItem('phoneNumberIv', obj.phoneNumberIv)
          localStorage.setItem('otp', obj.otp)
          localStorage.setItem('otpIv', obj.otpIv)
          localStorage.setItem('vendorPhone', response.data.data.vendorPhone)
          localStorage.setItem('vendorName', response.data.data.vendorName)

          // let showWelcomePage = localStorage.getItem('showWelcomePage')
          // if (!showWelcomePage) {
          //   navigate('/welcome-page')
          //   localStorage.setItem('showWelcomePage', true)
          // } else {
          navigate('/crane-driver-home')
          // }

        }else if (response.data.data.vendorType === "craneandrecoveryVan") {
          setupCommonLoginDetails(response)
          localStorage.setItem("userRole", "craneandrecoveryVan");
          localStorage.setItem('phoneNumber', obj.phoneNumber)
          localStorage.setItem('phoneNumberIv', obj.phoneNumberIv)
          localStorage.setItem('otp', obj.otp)
          localStorage.setItem('otpIv', obj.otpIv)
          localStorage.setItem('vendorPhone', response.data.data.vendorPhone)
          localStorage.setItem('vendorName', response.data.data.vendorName)

          // let showWelcomePage = localStorage.getItem('showWelcomePage')
          // if (!showWelcomePage) {
          //   navigate('/welcome-page')
          //   localStorage.setItem('showWelcomePage', true)
          // } else {
          navigate('/crane-driver-home')
          // }

        }  else if (response.data.data.vendorType === "workshop") {
          setupCommonLoginDetails(response)
          localStorage.setItem("userRole", "workshop");
          localStorage.setItem('phoneNumber', obj.phoneNumber)
          localStorage.setItem('phoneNumberIv', obj.phoneNumberIv)
          localStorage.setItem('otp', obj.otp)
          localStorage.setItem('otpIv', obj.otpIv)
        } else if (response.data.data.department === "Administration") {
          setupCommonLoginDetails(response)
          localStorage.setItem("userRole", "Administration");
          navigate("../Admin");
        } else if (response.data.data.department === "Sales") {
          setupCommonLoginDetails(response)
          localStorage.setItem("userRole", "sales");
          navigate("../Salesteam");
        } else if (response.data.data.customerDriverCode) {
          setupCommonLoginDetails(response)
          console.log("userRole", "customerDriver");
          localStorage.setItem("userRole", "customerDriver");
          navigate("../customer-home-page");
        } else if (response.data.data.vendorDriverCode) {
          if (response?.data?.data?.isActive === 0) {
            openModal({ title: 'Error', body: 'Login not allowed', iconType: 'error', autoClose: true, });
            return
          }
          setupCommonLoginDetails(response)
          console.log("userRole", "vendorDriver");
          localStorage.setItem("userRole", "vendorDriver");
          localStorage.setItem("userType", response.data.data.VendorType);
          navigate("../vendor-driver-home");

        } else {
          // For customer
          setupCommonLoginDetails(response)
          localStorage.setItem("userRole", "customer");
          localStorage.setItem("fromLogin", true);
          localStorage.setItem('justLoggedIn', 'true');
          navigate("../customer-home-page");
        }

      }
      else {
        openModal({
          title: 'Error',
          body: 'Internal server error',
          iconType: 'error',
          autoClose: true,
        });

      }

    } catch (error) {

      openModal({
        title: 'Error',
        body: error?.message,
        iconType: 'error',
        autoClose: true,
      });


    }
    finally {
      setIsLoading(false)
    }

  };


  const setupCommonLoginDetails = (response) => {
    localStorage.setItem("token", response.data.token);
    localStorage.setItem("userId", response.data.userId);
    localStorage.setItem("loginId", response.data.loginId);
    localStorage.setItem("loginTime", Date.now());
    document.cookie = `token=${response.data.token}; path=/; max-age=${48 * 60 * 60
      }; secure; samesite=strict`;

    if (window.ReactNativeWebView) {
      window.ReactNativeWebView.postMessage(JSON.stringify({
        type: "userId",
        userId: response.data.userId
      }));
    }
    if (response.data?.data.department) {
      localStorage.setItem("department", response.data.data.department);
    }
    setToken(response.data.token);
    setUserId(response.data.userId);
    setTypeOf(response.data.data.department ? response.data.data.department : "");
    dispatch(login({ userId, token }));
    if (rememberMe) {
      localStorage.setItem("rememberedEmail", email);
      localStorage.setItem("rememberedPassword", otp);
      localStorage.setItem("rememberMe", true);
    } else {
      localStorage.removeItem("rememberedaEmail");
      localStorage.removeItem("rememberedPassword");
      localStorage.removeItem("rememberMe");
    }

    setAlertInfo({
      show: true,
      messageAdvocate: response.data.message,
      severity: "success",
    });

    sendLoginNotification(response.data.userId, response.data.token);

  }

  const btnGetOtp = useRef(null)
  const btnLogin = useRef(null)

  const { openModal, modalData, closeModal } = useModal();

  const [hasError, setHasError] = useState(false);
  const [hasOtpError, setOtpHasError] = useState(false);

  const phoneInput = useRef(null)
  const otpInput = useRef(null)

  const [errorInputName, setErrorInputName] = useState(null);


  useEffect(() => {

    if (errorInputName === 'phone') {
      if (modalData.isOpen) {
        phoneInput.current.focus();
        setHasError(true)
      } else {
        setTimeout(() => {
          phoneInput.current?.focus();
          setHasError(true)

        }, 10);
      }
    }

    if (errorInputName === 'otp') {
      if (modalData.isOpen) {
        otpInput.current.focus();
      } else {
        setTimeout(() => {
          otpInput.current?.focus();
        }, 10);
      }

    }

    setTimeout(() => {
      otpInput.current?.focus();
    }, 1000);


  }, [modalData.isOpen]);

  const handlePhoneBlur = () => {
    if (phone.trim() === '') {
      setHasError(true);
    } else {
      setHasError(!/^[6-9]\d{9}$/.test(phone));
    }
  };

  useEffect(() => {

    const handleKeyDown = (e) => {

      // const activeElement = document.activeElement;
      // console.log("Key pressed:", e.key);
      // console.log("Active element:", activeElement);

      if (e.key === 'Escape' || e.key === ' ' || e.key === 'Enter') {

        if (modalData.isOpen) {

          // closeModal()
        }

      }

    };

    document.addEventListener('keydown', handleKeyDown);

    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [modalData.isOpen,]);

  useEffect(() => {

    if (!isCheckingAuth) {

      phoneInput.current.focus()
    }
  }, [isCheckingAuth])

  useEffect(() => {
    localStorage.removeItem('newNumber')
  }, [])

  const [timeLeft, setTimeLeft] = useState(120); // 2 minutes = 120 seconds
  const [showRetry, setShowRetry] = useState(null);
  const [optList, setOTPList] = useState([])

  useEffect(() => {
    let timer;

    if (timeLeft > 0) {
      setShowRetry(false); // Hide Retry button while countdown is active
      timer = setInterval(() => {
        setTimeLeft((prevTime) => {
          if (prevTime === 1) {
            clearInterval(timer);
            setShowRetry(true); // Show Retry when timer hits 0
            setShowLoginBtn(true)
            return 0;
          }
          return prevTime - 1;
        });
      }, 1000);
    }

    return () => clearInterval(timer);
  }, [timeLeft]);

  const formatTime = (seconds) => {
    const min = Math.floor(seconds / 60);
    const sec = seconds % 60;
    return `${min}:${sec < 10 ? "0" : ""}${sec}`;
  };

  const handleRetry = () => {
    // Logic to resend OTP
    console.log("Resend OTP...");
    setTimeLeft(120);
    setShowRetry(false);

    btnGetOtp.current.click()

  };

  const invoiceData = {
    customer_id: "60045093060",
    invoice_number: "INV-000003",
    date: "2025-08-22",
    due_date: "2025-08-30",
    line_items: [
      { name: "Product A", description: "Sample product", rate: 1000, quantity: 1 },
      { name: "Service B", description: "Service charge", rate: 500, quantity: 2 },
    ],
    notes: "Thanks for your business",
    terms: "Payment due within 7 days",
    currency_id: "2882034000000000064"
  };

  const location = useLocation();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const access = params.get("access_token");
    const refresh = params.get("refresh_token");

    console.log(params)

    if (access && refresh) {

      localStorage.setItem("zoho_access_token", access);
      localStorage.setItem("zoho_refresh_token", refresh);
      alert('Token saved')
    }
  }, []);

  return (

    <>
      {isCheckingAuth ? (
        <div /> // or loader/spinner
      ) : (
        <>
          <Navbar />
          {/* {loading && <Loader/> } */}
          <div className=" md:h-auto flex items-start justify-center md:px-0 px-0 bg-white pb-10">
            <div className="flex items-start justify-center flex-col] px-3 md:flex-row w-full max-w-[1200px] md:gap-[10%] gap-0 pr-0">
              <div className="max-w-[862px] w-full  md:block hidden">
                <img src='https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/login/login.jpg' alt="" />
              </div>




              <div className="max-w-[430px] pt-[30px] w-full">
                <h6 className="font-[500] font-satoshi text-[30px] text-[#000000] pb-[26px] m-0">
                  Sign up
                </h6>
                <p className="font-[400] font-satoshi text-[#515151] text-[17px] mb-0 pb-[52px]">
                  To create a new account, click <Link to="/signUp" className="no-underline">
                    <span className="font-[600] text-[#21A6E9] mt-2">
                      {" "}
                      here
                    </span>
                  </Link> to register.
                </p>

                <div className="flex flex-col gap-[42px]">
                  <div>

                    <h6 className="font-[500] font-satoshi text-[30px] text-[#000000] pb-[26px] m-0">
                      Log in
                    </h6>

                    <label
                      htmlFor=""
                      className="font-[500] font-satoshi text-[17px] text-[#000000] mb-0 pb-[13px]"
                    >
                      Mobile Number
                    </label>
                    <div className={`flex items-center gap-[10px] pb-[9px] border-b-[2px] border-solid h-[40px] box-border ${hasError ? 'border-red-500' : 'border-[#000000]'
                      }`}>
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-telephone" viewBox="0 0 16 16">
                        <path d="M3.654 1.328a.678.678 0 0 0-1.015-.063L1.605 2.3c-.483.484-.661 1.169-.45 1.77a17.6 17.6 0 0 0 4.168 6.608 17.6 17.6 0 0 0 6.608 4.168c.601.211 1.286.033 1.77-.45l1.034-1.034a.678.678 0 0 0-.063-1.015l-2.307-1.794a.68.68 0 0 0-.58-.122l-2.19.547a1.75 1.75 0 0 1-1.657-.459L5.482 8.062a1.75 1.75 0 0 1-.46-1.657l.548-2.19a.68.68 0 0 0-.122-.58zM1.884.511a1.745 1.745 0 0 1 2.612.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.68.68 0 0 0 .178.643l2.457 2.457a.68.68 0 0 0 .644.178l2.189-.547a1.75 1.75 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.6 18.6 0 0 1-7.01-4.42 18.6 18.6 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877z" />
                      </svg>
                      <input
                        ref={phoneInput}
                        type="text"
                        id="phone"
                        name="phone"
                        inputMode="numeric"
                        pattern="[0-9]*"
                        required
                        onChange={handlePhoneChange}
                        // onBlur={handlePhoneBlur}
                        value={phone}
                        className="font-[400] outline-none w-full font-satoshi text-[17px] text-[#515151] h-[24px] leading-[24px] p-0 m-0"
                        placeholder="Enter Mobile No."
                        maxLength={10}
                        onKeyDown={(e) => {
                          if (e.key === 'Enter') {

                            // btnSubmit.current.click()
                            if (showLoginBtn) {

                              btnGetOtp.current.click()
                            }
                            if (!showLoginBtn) {

                              btnLogin.current.click()
                            }

                            if (modalData.isOpen) {
                              closeModal()
                              // e.preventDefault()
                              // e.stopPropagation()
                            }
                          }
                        }}


                      />
                    </div>

                    {phoneError && (
                      <div
                        style={{
                          color: "red",
                          marginTop: "5px",
                          marginLeft: "20px",
                        }}
                      >
                        {phoneError}
                      </div>
                    )}

                  </div>
                  <div hidden={showLoginBtn}>
                    <label
                      htmlFor=""
                      className="font-[500] font-satoshi text-[17px] text-[#000000] mb-0 pb-[13px]"
                    >
                      OTP
                    </label>
                    <div className={`flex items-center gap-[10px] pb-[9px] border-b-[2px] border-solid h-[40px] box-border ${hasOtpError ? 'border-red-500' : 'border-[#000000]'
                      }`}>
                      <img src='https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/login/item3.svg' alt="" className="w-[20px] h-[20px]" />

                      {/* <Input
                        disableUnderline
                        inputRef={otpInput}
                        className="font-[400] w-full font-satoshi text-[17px] text-[#515151]"
                        placeholder="Enter OTP"
                        id="otp"
                        inputMode="numeric" // Triggers numeric keyboard
                        pattern="[0-9]*"     // Helps with validation
                        type="tel"           // TRIGGERS NUMERIC KEYPAD
                        value={otp}
                        onChange={handleOtpChange}
                        onKeyDown={(e) => {
                          if (e.key === 'Enter') {
                            if (showLoginBtn) {
                              btnGetOtp.current.click();
                            }
                            if (!showLoginBtn) {
                              btnLogin.current.click();
                            }
                            if (modalData.isOpen) {
                              closeModal();
                            }
                          }
                        }}
                        endAdornment={
                          <InputAdornment position="end">
                            <IconButton
                              aria-label="toggle password visibility"
                              onClick={togglePasswordVisibility}
                              edge="end"
                            >
                              {showPassword ? <VisibilityOff /> : <Visibility />}
                            </IconButton>
                          </InputAdornment>
                        }
                      /> */}

                      {/* <Input
                        disableUnderline
                        inputRef={otpInput}
                        className="font-[400] w-full font-satoshi text-[17px] text-[#515151]"
                        placeholder="Enter OTP"
                        id="otp"
                        type="tel"               // ✅ Best for mobile numeric keypad
                        inputMode="numeric"      // ✅ Helps mobile OS decide keyboard
                        pattern="[0-9]*"         // ✅ Forces numeric input
                        value={otp}
                        onChange={handleOtpChange}
                        onKeyDown={(e) => {
                          if (e.key === 'Enter') {
                            if (showLoginBtn) btnGetOtp.current.click();
                            else btnLogin.current.click();
                            if (modalData.isOpen) closeModal();
                          }
                        }}
                        endAdornment={
                          <InputAdornment position="end">
                            <IconButton
                              aria-label="toggle password visibility"
                              onClick={togglePasswordVisibility}
                              edge="end"
                            >
                              {showPassword ? <VisibilityOff /> : <Visibility />}
                            </IconButton>
                          </InputAdornment>
                        }
                      /> */}

                      {/* <Input
                        disableUnderline
                        inputRef={otpInput}
                        className="font-[400] w-full font-satoshi text-[17px] text-[#515151]"
                        placeholder="Enter OTP"
                        id="otp"
                        type={showPassword ? 'text' : 'password'} 
                        inputMode="numeric"
                        pattern="[0-9]*"
                        value={otp}
                        onChange={handleOtpChange}

                        onKeyDown={(e) => {
                          if (e.key === 'Enter') {
                            if (showLoginBtn) btnGetOtp.current.click();
                            else btnLogin.current.click();
                            if (modalData.isOpen) closeModal();
                          }
                        }}
                        endAdornment={
                          <InputAdornment position="end">
                            <IconButton
                              aria-label="toggle password visibility"
                              onClick={togglePasswordVisibility}
                              edge="end"
                            >
                              {showPassword ? <VisibilityOff /> : <Visibility />}
                            </IconButton>
                          </InputAdornment>
                        }
                      /> */}

                      <Input
                        disableUnderline
                        inputRef={otpInput}
                        className="font-[400] w-full font-satoshi text-[17px] text-[#515151]"
                        placeholder="Enter OTP"
                        id="otp"
                        type={showPassword ? 'text' : 'password'}
                        value={otp}
                        onChange={handleOtpChange}
                        inputProps={{
                          maxLength: 6,
                          inputMode: 'numeric',
                          pattern: '[0-9]*'
                        }}
                        onKeyDown={(e) => {
                          if (e.key === 'Enter') {
                            if (showLoginBtn) btnGetOtp.current.click();
                            else btnLogin.current.click();
                            if (modalData.isOpen) closeModal();
                          }
                        }}
                        endAdornment={
                          <InputAdornment position="end">
                            <IconButton
                              aria-label="toggle password visibility"
                              onClick={togglePasswordVisibility}
                              edge="end"
                            >
                              {showPassword ? <VisibilityOff /> : <Visibility />}
                            </IconButton>
                          </InputAdornment>
                        }
                      />





                    </div>

                    <div className="row mt-3 text-center">
                      <div>
                        {showRetry ? (
                          <button onClick={handleRetry}>Resend OTP</button>
                        ) : (
                          <p>Resend OTP in: {formatTime(timeLeft)}</p>
                        )}
                      </div>
                    </div>


                  </div>
                  <div className='font-satoshi text-[14px] mt-3 text-center space-y-1'>

                    <p>
                      By Login, I Accept{" "}
                      <span
                        onClick={() => {
                          const link = document.createElement("a");
                          link.href = "/terms_&_condition";
                          link.target = "_blank";
                          link.rel = "noopener noreferrer";
                          document.body.appendChild(link);
                          link.click();
                          document.body.removeChild(link);
                        }}
                        className="text-blue-400 cursor-pointer"
                      >
                        T & C
                      </span>{" "}
                      and{" "}
                      <span
                        onClick={() => {
                          const link = document.createElement("a");
                          link.href = "/privacy-policy";
                          link.target = "_blank";
                          link.rel = "noopener noreferrer";
                          document.body.appendChild(link);
                          link.click();
                          document.body.removeChild(link);
                        }}
                        className="text-blue-400 cursor-pointer"
                      >
                        Privacy Policy
                      </span>
                    </p>

                    <p>
                      Read Account Deletion Policy{" "}
                      <span
                        onClick={() => {
                          const link = document.createElement("a");
                          link.href = "/delete-account-page";
                          link.target = "_blank";
                          link.rel = "noopener noreferrer";
                          document.body.appendChild(link);
                          link.click();
                          document.body.removeChild(link);
                        }}
                        className="text-blue-400 cursor-pointer"
                      >
                        Here
                      </span>
                    </p>

                    <p>
                      Cancellation Refund Policy{" "}
                      <span
                        onClick={() => {
                          const link = document.createElement("a");
                          link.href = "/cancellation-refund-policy";
                          link.target = "_blank";
                          link.rel = "noopener noreferrer";
                          document.body.appendChild(link);
                          link.click();
                          document.body.removeChild(link);
                        }}
                        className="text-blue-400 cursor-pointer"
                      >
                        Here
                      </span>
                    </p>
                  </div>

                  <button
                    ref={btnGetOtp}
                    hidden={!showLoginBtn}
                    onClick={getOtp}
                    className="bg-[#21A6E9] rounded-[32px] py-[14px] font-[500] font-satoshi text-[17px] text-[#FFFFFF]"
                  >

                    {isLoading && (
                      <span
                        className="spinner-border spinner-border-sm me-1"></span>
                    )}

                    Get OTP
                  </button>

                  <button
                    ref={btnLogin}
                    hidden={showLoginBtn}
                    onClick={handleSubmit}
                    className="bg-[#21A6E9] rounded-[32px] py-[14px] font-[500] font-satoshi text-[17px] text-[#FFFFFF]"
                  >
                    {isLoading && (
                      <span
                        className="spinner-border spinner-border-sm me-1"></span>
                    )}
                    Login
                  </button>


                  {/* <div className="flex justify-end">
                <Link to="/LoginPageClient" className="no-underline">
                  <span className="font-[600] text-[#21A6E9] mt-2">
                    Vendor Registration!
                  </span>
                </Link>
              </div> */}

                </div>
              </div>
            </div>
          </div>

          {/* <Footer /> */}
        </>
      )}
    </>



  );
}

export default Login;





